exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#modals-container > div.v--modal[data-v-795f9443] {\n  height: 900px;\n}\n#modalConfirmRegister[data-v-795f9443] {\n  background-color: white;\n}\n", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/components/popup/ModalConfirmRegister.vue"],"names":[],"mappings":";AACA;EACE,cAAc;CACf;AACD;EACE,wBAAwB;CACzB","file":"ModalConfirmRegister.vue","sourcesContent":["\n#modals-container > div.v--modal[data-v-795f9443] {\n  height: 900px;\n}\n#modalConfirmRegister[data-v-795f9443] {\n  background-color: white;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-795f9443","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/popup/ModalConfirmRegister.vue
// module id = Ej2F
// module chunks = 6 8